import React, {useEffect} from 'react';
import s from './subscriptionEndingInfoPopup.module.scss'
import {useDispatch, useSelector} from "react-redux";
import {financeSelector} from "../../../../../../redux/slices/financeSlice";
import {globalDataSelector, setNotifyPopup} from "../../../../../../redux/slices/globalDataSlice";
import {useTranslation} from "react-i18next";
import SvgSelector from "../../../../../../components/SvgSelector/SvgSelector";
import {setIsNotified} from "../../../../../../storage/user";
import {setSubscriptionEndingPopupActive, subscriptionSelector} from "../../../../../../redux/slices/subscriptionSlice";
import SliderLoader from "../../../../../../components/UiKit/Loader/SliderLoader/SliderLoader";
import CancelButton from "../../../../../../components/UiKit/Buttons/CancelBtn/CancelBtn";
import PrimaryBtn from "../../../../../../components/UiKit/Buttons/PrimaryBorderBtn/PrimaryBorderBtn";
import {convertDate} from "../../../../../../utils/helpers/formatTime";
import {setSubscriptionEndingLimit1, setSubscriptionEndingLimit3} from "../../../../../../storage/subscription";
import {useNavigate} from "react-router-dom";


const SubscriptionEndingInfoPopup = () => {
    const {topUpBalanceIsActive} = useSelector(financeSelector);
    const {exitPopup, isCollapsedSidebar} =
        useSelector(globalDataSelector);

    const {subscriptionsList, isSubscriptionEndingPopupActive} = useSelector(subscriptionSelector);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const {t} = useTranslation();

    useEffect(() => {
        if (exitPopup && !topUpBalanceIsActive) {
            // handleClosePopup();
        } else {
        }
    }, [exitPopup]);

    const activeSubscription = subscriptionsList.find(item => item?.is_active === true)

    const {
        name: subscriptionName,
        end_date_count: subscriptionEndDateCount,
        start_date: subscriptionStartDate,
        bgImage: subscriptionBgImage
    } = activeSubscription || {}

    const startDateOfSubscription = convertDate(subscriptionStartDate, 'DMY')

    const closePopup = () => {
        dispatch(setSubscriptionEndingPopupActive(false))

        if (subscriptionEndDateCount > 1) {
            setSubscriptionEndingLimit3()
        } else {
            setSubscriptionEndingLimit1()
        }
    }

    return (
        <div
            className={`${s.popupWrapper} ${isSubscriptionEndingPopupActive ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
        >
            <div className={isSubscriptionEndingPopupActive ? `${s.popup} ${s.active}` : s.popup}
            >
                <div className={s.header}
                     style={{backgroundImage: `url(${subscriptionBgImage})`}}
                >
                    <span className={s.iconWrapper}><SvgSelector id='subscriptions-icon'/></span>
                    <p className={s.title}>{t('info_about_subscription')}</p>
                </div>

                <div className={s.body}>
                    <p className={s.attentionTitle}>
                        {t('subscription_ending')}
                    </p>
                    <div className={s.infoDetails}>
                        <div className={s.lastingDays}>
                            <span className={s.detailTitle}>{t('days_remaining')}:</span>
                            <span
                                className={`
                                    ${s.daysCount}
                                    ${subscriptionEndDateCount < 2 ? s.red : ''}
                                    ${subscriptionEndDateCount > 1 && subscriptionEndDateCount < 4 ? s.orange : ''}
                                `}>

                                {subscriptionEndDateCount}

                            </span>
                        </div>
                        <div className={s.dateOfSubscription}>
                            <span className={s.detailTitle}>{t('subscription_date')}:</span>
                            <span className={s.date}>{startDateOfSubscription}</span>
                        </div>
                    </div>
                    <p className={s.additionalSubscriptionInfo}>
                        {t('continue_subscription_note')}
                    </p>
                </div>

                <div className={s.footer}>
                    <button
                        className={s.whiteBorderBtn}
                        onClick={closePopup}
                    >
                        {
                            t('continue')
                        }
                    </button>

                    <button
                        className={s.blueBorderBtn}
                        onClick={() => {
                            closePopup()
                            navigate('/subscriptions')
                        }}
                    >
                        {
                            t('subscriptions')
                        }
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionEndingInfoPopup;